import store from "../../store";
import register from './register/register.vue';

window.USER_REG =  new Vue({
	store,
	el: 'div#user_register',

	data () {
		return {

		}
	},
	created () {

	},
	components : {
		register,
	}
});
